document.addEventListener('click', function (e) {
    var b = e.target.closest('.pw__nav-search');
    if (!b || !b.dataset.searchUrl) return;
    window.location.href = b.dataset.searchUrl;
});
